import { CeruleanButton } from 'components/Button'
import Column from 'components/Column'
import InputContainer from 'components/InputContainer'
import formName from 'constants/formName'
import { selectors } from 'data'
import { WhitelistAddressFormType } from 'data/types'
import messages from 'lang'
import React from 'react'
import { useIntl } from 'react-intl'
import { useSelector } from 'react-redux'
import { Field, getFormValues, InjectedFormProps } from 'redux-form'
import FirstSetup2FA from 'scenes/Account/FirstSetup2FA'
import styled from 'styled-components'
import { validator } from 'utils'

import Container from '../Container'
import { StyledInput, StyledSelectOption } from './styles'

const StyledContainer = styled(Container)`
  text-align: left;
`

type PropsType = InjectedFormProps<WhitelistAddressFormType>

const AddAddress = (props: PropsType) => {
  const { invalid } = props
  const intl = useIntl()
  const values = useSelector(getFormValues(formName.WHITELIST_ADDRESS)) as WhitelistAddressFormType
  const whitelistCapabilities = useSelector(selectors.payments.getWhitelistCapabilities).sort(
    (a, b) => ((a.text ?? '') > (b.text ?? '') ? 1 : -1)
  )
  const { currency } = values
  const twoFactorStatus = useSelector(selectors.auth.getTwoFactorStatus)
  const has2FASetup = twoFactorStatus && twoFactorStatus.length > 0

  return (
    <StyledContainer>
      <Column>
        <InputContainer>
          <Field
            component={StyledSelectOption}
            e2e='whitelistAddressCapabilitiesDropdown'
            items={whitelistCapabilities}
            label={intl.formatMessage(messages.whitelist_address)}
            name='currency'
            validate={[validator.required]}
            variant='normal'
          />
          <Field
            component={StyledInput}
            e2e='whitelistAddressAddress'
            label={intl.formatMessage(messages.label_code)}
            name='address'
            placeholder={intl.formatMessage(messages.address)}
            style={{ borderRadius: 'initial' }}
            type='text'
            validate={[validator.required]}
          />
          {currency === 'XLM' && (
            <Field
              component={StyledInput}
              e2e='whitelistAddressXlmMemo'
              name='memo'
              placeholder={intl.formatMessage(messages.label_memo, {
                value: currency
              })}
              showError={false}
              style={{ borderRadius: 'initial', borderTop: '1px solid #CCC' }}
              type='text'
            />
          )}
          {currency === 'XRP' && (
            <Field
              component={StyledInput}
              e2e='whitelistAddressXrpTag'
              label={intl.formatMessage(messages.label_code)}
              name='tag'
              placeholder={intl.formatMessage(messages.label_tag, {
                value: currency
              })}
              showError
              style={{ borderRadius: 'initial', borderTop: '1px solid #CCC' }}
              type='text'
              validate={[validator.hasNoWhitespace]}
            />
          )}
          <Field
            component={StyledInput}
            e2e='whitelistAddressName'
            label={intl.formatMessage(messages.label_code)}
            name='name'
            placeholder={intl.formatMessage(messages.whitelist_address_desc)}
            type='text'
            validate={[validator.required]}
          />
        </InputContainer>

        {has2FASetup ? (
          <InputContainer>
            <Field
              component={StyledInput}
              data-lpignore='true'
              e2e='2faCode'
              label={intl.formatMessage(messages.label_code)}
              name='code'
              placeholder={intl.formatMessage(messages.title_verify_2fa)}
              type={twoFactorStatus!.includes('WALLET_YUBIKEY') ? 'password' : 'text'}
              validate={[validator.required]}
            />
          </InputContainer>
        ) : (
          <FirstSetup2FA />
        )}

        <CeruleanButton disabled={invalid} e2e='addAddressButton' type='submit'>
          {intl.formatMessage(messages.whitelist_address)}
        </CeruleanButton>
      </Column>
    </StyledContainer>
  )
}

export default AddAddress
